export default {
  path: '/crm',
  component: () => import('@/views/crm/Index'),
  children: [
    {
      path: 'leads',
      component: () => import('@/views/crm/leads/Index'),
      children: [
        {
          path: '',
          name: 'leads-list',
          component: () => import('@/views/crm/leads/List'),
          meta: {
            title: 'Leads',
            roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'marketing_supervisor', 'support']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/crm/leads/detail/Index'),
          children: [
            {
              path: '',
              component: () => import('@/views/crm/leads/detail/Layout'),
              children: [
                {
                  path: '',
                  name: 'leads-detail-lead',
                  component: () => import('@/views/crm/leads/detail/Lead'),
                  meta: {
                    roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'marketing_supervisor', 'support']
                  }
                },
                {
                  path: 'invoices',
                  name: 'leads-detail-invoices',
                  component: () => import('@/views/crm/leads/detail/Invoices'),
                  meta: {
                    roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'support']
                  }
                },
                {
                  path: 'reservations',
                  name: 'leads-detail-reservations',
                  component: () => import('@/views/crm/leads/detail/Reservations'),
                  meta: {
                    roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'support']
                  }
                },
                {
                  path: 'status',
                  name: 'leads-detail-status',
                  component: () => import('@/views/crm/leads/detail/Status'),
                  meta: {
                    roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'marketing_supervisor', 'support']
                  }
                },
                {
                  path: 'advertising',
                  name: 'leads-detail-advertising',
                  component: () => import('@/views/crm/leads/detail/Advertising'),
                  meta: {
                    roles: []
                  }
                },
              ]
            }
          ],
        },
      ]
    },
    {
      path: 'trengo-tickets',
      component: () => import('@/views/crm/trengo/Layout'),
      children: [
        {
          path: '',
          name: 'trengo-tickets',
          component: () => import('@/views/crm/trengo/TrengoTickets'),
          meta: {
            title: 'Trengo tickets',
            roles: ['general_manager']
          }
        },
        {
          path: 'whatsApp-webhooks',
          name: 'whatsApp-webhooks',
          component: () => import('@/views/crm/trengo/WhatsAppWebhooks'),
          meta: {
            title: 'WhatsApp webhooks',
            roles: ['general_manager']
          }
        },
      ]
    },
    {
      path: 'trengo-tickets/:id',
      name: 'trengo-tickets-detail',
      component: () => import('@/views/crm/trengo/Detail'),
      meta: {
        title: 'Trengo tickets',
        roles: ['general_manager']
      }
    },
    {
      path: 'allowance',
      component: () => import('@/views/crm/allowance/Index'),
      children: [
        {
          path: '',
          name: 'allowance-list',
          component: () => import('@/views/crm/allowance/List'),
          meta: {
            title: 'Allowances',
            roles: ['general_manager']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/crm/allowance/detail/Layout'),
          children: [
            {
              path: '',
              name: 'allowance-employee',
              component: () => import('@/views/crm/allowance/detail/Employee'),
              meta: {
                title: 'Allowance employee',
                roles: ['general_manager']
              }
            },
            {
              path: 'log',
              name: 'allowance-log',
              component: () => import('@/views/crm/allowance/detail/Log'),
              meta: {
                title: 'Allowance log',
                roles: ['general_manager']
              }
            },
          ],
        },
      ]
    },
    {
      path: 'analytics',
      component: () => import('@/views/crm/analytics/Layout'),
      children: [
        {
          path: '',
          name: 'crm-analytics-requests',
          component: () => import('@/views/crm/analytics/Requests'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'sales_supervisor', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'managers',
          name: 'crm-analytics-managers-requests',
          component: () => import('@/views/crm/analytics/ManagersRequests'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'sales_supervisor', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'sales',
          name: 'crm-analytics-sales',
          component: () => import('@/views/crm/analytics/Sales'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'sales_supervisor', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'sales/managers',
          name: 'crm-analytics-managers-sales',
          component: () => import('@/views/crm/analytics/ManagersSales'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'sales_supervisor', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'advertising',
          name: 'crm-analytics-advertising',
          component: () => import('@/views/crm/analytics/Advertising'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'sales_supervisor', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'urls',
          name: 'crm-analytics-urls',
          component: () => import('@/views/crm/analytics/URLs'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'sales_supervisor', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'regions',
          name: 'crm-analytics-regions',
          component: () => import('@/views/crm/analytics/Regions'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'sales_supervisor', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'sales/regions',
          name: 'crm-analytics-regions-sales',
          component: () => import('@/views/crm/analytics/RegionsSales'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'sales_supervisor', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'sales/urls',
          name: 'crm-analytics-urls-sales',
          component: () => import('@/views/crm/analytics/URLsSales'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'sales_supervisor', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'clients-profile',
          name: 'crm-analytics-clients-profile',
          component: () => import('@/views/crm/analytics/ClientsProfile'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'sales_supervisor', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'expenses',
          name: 'crm-analytics-expenses',
          component: () => import('@/views/crm/analytics/Expenses'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'api',
          name: 'crm-analytics-api',
          component: () => import('@/views/crm/analytics/API'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager']
          }
        },
        // {
        //   path: 'tour-dates',
        //   name: 'crm-analytics-tour-dates',
        //   component: () => import('@/views/crm/analytics/TourDates'),
        //   meta: {
        //     title: 'CRM Analytics',
        //     roles: ['general_manager', 'sales_manager']
        //   }
        // },
      ],
    },
  ]
}
